export default __webpack_public_path__ + "static/media/scale_white.e73428d9.svg";